const EVENT_NAMES = {
  ADD: 'snackbar:add',
};

const Events = {
  Add(options = {}) {
    return new CustomEvent(EVENT_NAMES.ADD, {
      detail: options,
    });
  },
};

export { EVENT_NAMES, Events };
